var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blue-background"},[_c('the-header'),_c('vs-row',[_c('vs-col',{attrs:{"lg":3,"sm":12}},[_c('side-bar')],1),_c('vs-col',{staticClass:"mml-1 mb-8",staticStyle:{"position":"relative","display":"block"},attrs:{"lg":9,"sm":12}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }